import { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase-config';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, signOut } from 'firebase/auth';

const AuthContext = createContext({});
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState({});
    const login = (email, password) => createUserWithEmailAndPassword(auth, email, password);
    const signIn = (email, password) => signInWithEmailAndPassword(auth, email, password);
    const signUp = () => signOut(auth);
    useEffect(() => {
        return onAuthStateChanged(auth, (currentUser) => setUser(currentUser));
    }, []);

    const value = {
        user,
        login,
        signIn,
        signUp
    };
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}